/** Visual refresh box shadow assignments — shared between light and dark mode. */
export const vrBoxShadowAssignments = {
  '--dt-box-shadows-surface-flat-rest': 'var(--_vr-10)',
  '--dt-box-shadows-surface-flat-hover': 'var(--_vr-20)',
  '--dt-box-shadows-surface-flat-active': 'var(--_vr-10)',
  '--dt-box-shadows-surface-flat-drag': 'var(--_vr-50)',
  '--dt-box-shadows-surface-raised-rest': 'var(--_vr-20)',
  '--dt-box-shadows-surface-raised-hover': 'var(--_vr-30)',
  '--dt-box-shadows-surface-raised-active': 'var(--_vr-20)',
  '--dt-box-shadows-surface-raised-drag': 'var(--_vr-50)',
  '--dt-box-shadows-surface-floating-rest': 'var(--_vr-30)',
  '--dt-box-shadows-surface-floating-hover': 'var(--_vr-40)',
  '--dt-box-shadows-surface-floating-active': 'var(--_vr-30)',
  '--dt-box-shadows-surface-floating-drag': 'var(--_vr-50)',
};

/** Visual refresh generated overrides — light mode. */
export const vrLightGeneratedOverrides = {
  '--dt-box-shadows-surface-flat-rest': '0px 0px 0px 1px #3838420d',
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 4px 8px -2px #38384212',
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #3838420d',
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 7px 17px -2px #38384252',
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 4px 8px -2px #38384212',
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 5px 11px -2px #38384229',
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 4px 8px -2px #38384212',
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 7px 17px -2px #38384252',
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 5px 11px -2px #38384229',
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 6px 14px -2px #3838423d',
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 5px 11px -2px #38384229',
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #38384208, 0px 1px 2px #3838420d, 0px 7px 17px -2px #38384252',
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #31323a1f, inset 0px -1px 0px #31323a14, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fff',
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #31323a1f, inset 0px -1px 0px #31323a14, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #eff0f2',
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #31323a1f, inset 0px -1px 0px #31323a14, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #eaeaed',
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #0000004d, inset 0px -1px 0px #0000008c, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #31323a0f, inset 0px -1px 0px #31323a0a, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #0017ae0f, inset 0px -1px 0px #0017ae1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #dde8fc',
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #0017ae0f, inset 0px -1px 0px #0017ae1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #d1e1fd',
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #0017ae0f, inset 0px -1px 0px #0017ae1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #c3d8ff',
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #0017ae33, inset 0px -1px 0px #0017ae4d, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #31323a0f, inset 0px -1px 0px #31323a0a, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #0042220f, inset 0px -1px 0px #0042221a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #e2f2e8',
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #0042220f, inset 0px -1px 0px #0042221a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #d8efe2',
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #0042220f, inset 0px -1px 0px #0042221a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #cdecda',
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #00422226, inset 0px -1px 0px #0042224d, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #31323a0f, inset 0px -1px 0px #31323a0a, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #4c34000f, inset 0px -1px 0px #4c34001a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fdf3dd',
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #4c34000f, inset 0px -1px 0px #4c34001a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fdefd1',
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #4c34000f, inset 0px -1px 0px #4c34001a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fdebc2',
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #4c34001a, inset 0px -1px 0px #4c340033, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #31323a0f, inset 0px -1px 0px #31323a0a, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #80000c0f, inset 0px -1px 0px #80000c1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fbe1df',
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #80000c0f, inset 0px -1px 0px #80000c1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fbd6d4',
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #80000c0f, inset 0px -1px 0px #80000c1a, 0px 1px 1px -1px #3838421f, inset 0px 0px 0px 1px #fbcbc7',
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #80000c33, inset 0px -1px 0px #80000c4d, 0px 1px 1px -1px #3838421f',
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #31323a0f, inset 0px -1px 0px #31323a0a, 0px 1px 1px -1px #3838421f',
  '--dt-colors-theme-foreground-10': '#383842',
  '--dt-colors-theme-foreground-20': '#fff',
  '--dt-colors-theme-background-10': '#fafafb',
  '--dt-colors-theme-background-20': '#fff',
  '--dt-colors-theme-background-shell-default': '#f4f4f6',
  '--dt-colors-theme-background-base-default': '#fafafb',
  '--dt-colors-theme-background-surface-backdrop': '#38384266',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#fafafbcc',
  '--dt-colors-theme-background-surface-default': '#fff',
  '--dt-colors-theme-background-container-neutral-subdued': '#fafafb',
  '--dt-colors-theme-neutral-10': '#f4f4f6',
  '--dt-colors-theme-neutral-20': '#eff0f2',
  '--dt-colors-theme-neutral-30': '#eaeaed',
  '--dt-colors-theme-neutral-40': '#e4e4e7',
  '--dt-colors-theme-neutral-50': '#dddee1',
  '--dt-colors-theme-neutral-60': '#d6d7da',
  '--dt-colors-theme-neutral-70': '#34353d',
  '--dt-colors-theme-neutral-80': '#23242c',
  '--dt-colors-theme-neutral-90': '#14151c',
  '--dt-colors-theme-primary-10': '#f0f4fa',
  '--dt-colors-theme-primary-20': '#e7eefb',
  '--dt-colors-theme-primary-30': '#dde8fc',
  '--dt-colors-theme-primary-40': '#d1e1fd',
  '--dt-colors-theme-primary-50': '#c3d8ff',
  '--dt-colors-theme-primary-60': '#b5cfff',
  '--dt-colors-theme-primary-70': '#1966ff',
  '--dt-colors-theme-primary-80': '#0254ed',
  '--dt-colors-theme-primary-90': '#0042da',
  '--dt-colors-theme-success-10': '#f1f6f3',
  '--dt-colors-theme-success-20': '#eaf4ee',
  '--dt-colors-theme-success-30': '#e2f2e8',
  '--dt-colors-theme-success-40': '#d8efe2',
  '--dt-colors-theme-success-50': '#cdecda',
  '--dt-colors-theme-success-60': '#c1e8d2',
  '--dt-colors-theme-success-70': '#00c181',
  '--dt-colors-theme-success-80': '#2cd08f',
  '--dt-colors-theme-success-90': '#43df9d',
  '--dt-colors-theme-warning-10': '#fdf9f1',
  '--dt-colors-theme-warning-20': '#fdf7e8',
  '--dt-colors-theme-warning-30': '#fdf3dd',
  '--dt-colors-theme-warning-40': '#fdefd1',
  '--dt-colors-theme-warning-50': '#fdebc2',
  '--dt-colors-theme-warning-60': '#fde6b3',
  '--dt-colors-theme-warning-70': '#fdc300',
  '--dt-colors-theme-warning-80': '#ffd12b',
  '--dt-colors-theme-warning-90': '#ffe27f',
  '--dt-colors-theme-critical-10': '#f9f1f1',
  '--dt-colors-theme-critical-20': '#faeae9',
  '--dt-colors-theme-critical-30': '#fbe1df',
  '--dt-colors-theme-critical-40': '#fbd6d4',
  '--dt-colors-theme-critical-50': '#fbcbc7',
  '--dt-colors-theme-critical-60': '#fabeba',
  '--dt-colors-theme-critical-70': '#e01032',
  '--dt-colors-theme-critical-80': '#cd0022',
  '--dt-colors-theme-critical-90': '#b50019',
  '--dt-colors-background-base-default': '#fafafb',
  '--dt-colors-background-surface-backdrop': '#38384266',
  '--dt-colors-background-surface-backdrop-embedded': '#fafafbcc',
  '--dt-colors-background-surface-default': '#fff',
  '--dt-colors-background-container-neutral-subdued': '#fafafb',
  '--dt-colors-background-container-neutral-default': '#f4f4f6',
  '--dt-colors-background-container-neutral-emphasized': '#eff0f2',
  '--dt-colors-background-container-neutral-accent': '#34353d',
  '--dt-colors-background-container-primary-default': '#f0f4fa',
  '--dt-colors-background-container-primary-emphasized': '#e7eefb',
  '--dt-colors-background-container-primary-accent': '#1966ff',
  '--dt-colors-background-container-success-default': '#f1f6f3',
  '--dt-colors-background-container-success-emphasized': '#eaf4ee',
  '--dt-colors-background-container-success-accent': '#00c181',
  '--dt-colors-background-container-warning-default': '#fdf9f1',
  '--dt-colors-background-container-warning-emphasized': '#fdf7e8',
  '--dt-colors-background-container-warning-accent': '#fdc300',
  '--dt-colors-background-container-critical-default': '#f9f1f1',
  '--dt-colors-background-container-critical-emphasized': '#faeae9',
  '--dt-colors-background-container-critical-accent': '#e01032',
  '--dt-colors-background-field-neutral-disabled': '#eaeaed80',
  '--dt-colors-background-field-neutral-default': '#eff0f200',
  '--dt-colors-background-field-neutral-default-hover': '#eff0f2',
  '--dt-colors-background-field-neutral-default-active': '#eaeaed',
  '--dt-colors-background-field-neutral-emphasized': '#eaeaed',
  '--dt-colors-background-field-neutral-emphasized-hover': '#e4e4e7',
  '--dt-colors-background-field-neutral-emphasized-active': '#dddee1',
  '--dt-colors-background-field-neutral-accent': '#34353d',
  '--dt-colors-background-field-neutral-accent-hover': '#23242c',
  '--dt-colors-background-field-neutral-accent-active': '#14151c',
  '--dt-colors-background-field-primary-disabled': '#eaeaed80',
  '--dt-colors-background-field-primary-default': '#dde8fc00',
  '--dt-colors-background-field-primary-default-hover': '#d1e1fd',
  '--dt-colors-background-field-primary-default-active': '#c3d8ff',
  '--dt-colors-background-field-primary-emphasized': '#dde8fc',
  '--dt-colors-background-field-primary-emphasized-hover': '#d1e1fd',
  '--dt-colors-background-field-primary-emphasized-active': '#c3d8ff',
  '--dt-colors-background-field-primary-accent': '#1966ff',
  '--dt-colors-background-field-primary-accent-hover': '#0254ed',
  '--dt-colors-background-field-primary-accent-active': '#0042da',
  '--dt-colors-background-field-success-disabled': '#eaeaed80',
  '--dt-colors-background-field-success-default': '#e2f2e800',
  '--dt-colors-background-field-success-default-hover': '#d8efe2',
  '--dt-colors-background-field-success-default-active': '#cdecda',
  '--dt-colors-background-field-success-emphasized': '#e2f2e8',
  '--dt-colors-background-field-success-emphasized-hover': '#d8efe2',
  '--dt-colors-background-field-success-emphasized-active': '#cdecda',
  '--dt-colors-background-field-success-accent': '#00c181',
  '--dt-colors-background-field-success-accent-hover': '#2cd08f',
  '--dt-colors-background-field-success-accent-active': '#43df9d',
  '--dt-colors-background-field-warning-disabled': '#eaeaed80',
  '--dt-colors-background-field-warning-default': '#fdf3dd00',
  '--dt-colors-background-field-warning-default-hover': '#fdefd1',
  '--dt-colors-background-field-warning-default-active': '#fdebc2',
  '--dt-colors-background-field-warning-emphasized': '#fdf3dd',
  '--dt-colors-background-field-warning-emphasized-hover': '#fdefd1',
  '--dt-colors-background-field-warning-emphasized-active': '#fdebc2',
  '--dt-colors-background-field-warning-accent': '#fdc300',
  '--dt-colors-background-field-warning-accent-hover': '#ffd12b',
  '--dt-colors-background-field-warning-accent-active': '#ffe27f',
  '--dt-colors-background-field-critical-disabled': '#eaeaed80',
  '--dt-colors-background-field-critical-default': '#fbe1df00',
  '--dt-colors-background-field-critical-default-hover': '#fbd6d4',
  '--dt-colors-background-field-critical-default-active': '#fbcbc7',
  '--dt-colors-background-field-critical-emphasized': '#fbe1df',
  '--dt-colors-background-field-critical-emphasized-hover': '#fbd6d4',
  '--dt-colors-background-field-critical-emphasized-active': '#fbcbc7',
  '--dt-colors-background-field-critical-accent': '#e01032',
  '--dt-colors-background-field-critical-accent-hover': '#cd0022',
  '--dt-colors-background-field-critical-accent-active': '#b50019',
  '--dt-colors-background-shell-default': '#f4f4f6',
  '--dt-colors-border-neutral-disabled': '#e4e4e780',
  '--dt-colors-border-neutral-default': '#e4e4e7',
  '--dt-colors-border-neutral-default-hover': '#dddee1',
  '--dt-colors-border-neutral-default-active': '#d6d7da',
  '--dt-colors-border-neutral-accent': '#5c5d66',
  '--dt-colors-border-neutral-accent-hover': '#46474f',
  '--dt-colors-border-neutral-accent-active': '#31323a',
  '--dt-colors-border-neutral-on-accent-disabled': '#f6f6fa33',
  '--dt-colors-border-neutral-on-accent-default': '#f6f6fa',
  '--dt-colors-border-neutral-on-accent-default-hover': '#f6f6facc',
  '--dt-colors-border-neutral-on-accent-default-active': '#f6f6fa99',
  '--dt-colors-border-neutral-subdued': '#eaeaed',
  '--dt-colors-border-neutral-subdued-hover': '#dddee1',
  '--dt-colors-border-neutral-subdued-active': '#d6d7da',
  '--dt-colors-border-primary-disabled': '#e4e4e780',
  '--dt-colors-border-primary-default': '#d1e1fd',
  '--dt-colors-border-primary-default-hover': '#c3d8ff',
  '--dt-colors-border-primary-default-active': '#b5cfff',
  '--dt-colors-border-primary-accent': '#0b56e5',
  '--dt-colors-border-primary-accent-hover': '#003ac9',
  '--dt-colors-border-primary-accent-active': '#0017ae',
  '--dt-colors-border-primary-on-accent-disabled': '#f7f9fc33',
  '--dt-colors-border-primary-on-accent-default': '#f7f9fc',
  '--dt-colors-border-primary-on-accent-default-hover': '#f7f9fccc',
  '--dt-colors-border-primary-on-accent-default-active': '#f7f9fc99',
  '--dt-colors-border-success-disabled': '#e4e4e780',
  '--dt-colors-border-success-default': '#d8efe2',
  '--dt-colors-border-success-default-hover': '#cdecda',
  '--dt-colors-border-success-default-active': '#c1e8d2',
  '--dt-colors-border-success-accent': '#007242',
  '--dt-colors-border-success-accent-hover': '#005b33',
  '--dt-colors-border-success-accent-active': '#004222',
  '--dt-colors-border-success-on-accent-disabled': '#080c0a33',
  '--dt-colors-border-success-on-accent-default': '#080c0a',
  '--dt-colors-border-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-border-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-border-warning-disabled': '#e4e4e780',
  '--dt-colors-border-warning-default': '#fdefd1',
  '--dt-colors-border-warning-default-hover': '#fdebc2',
  '--dt-colors-border-warning-default-active': '#fde6b3',
  '--dt-colors-border-warning-accent': '#815d00',
  '--dt-colors-border-warning-accent-hover': '#664800',
  '--dt-colors-border-warning-accent-active': '#4c3400',
  '--dt-colors-border-warning-on-accent-disabled': '#0d0b0733',
  '--dt-colors-border-warning-on-accent-default': '#0d0b07',
  '--dt-colors-border-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-border-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-border-critical-disabled': '#e4e4e780',
  '--dt-colors-border-critical-default': '#fbd6d4',
  '--dt-colors-border-critical-default-hover': '#fbcbc7',
  '--dt-colors-border-critical-default-active': '#fabeba',
  '--dt-colors-border-critical-accent': '#c80026',
  '--dt-colors-border-critical-accent-hover': '#a60016',
  '--dt-colors-border-critical-accent-active': '#80000c',
  '--dt-colors-border-critical-on-accent-disabled': '#faf5f533',
  '--dt-colors-border-critical-on-accent-default': '#faf5f5',
  '--dt-colors-border-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-border-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-text-neutral-disabled': '#5c5d6680',
  '--dt-colors-text-neutral-subdued': '#5c5d66',
  '--dt-colors-text-neutral-subdued-hover': '#46474f',
  '--dt-colors-text-neutral-subdued-active': '#31323a',
  '--dt-colors-text-neutral-default': '#31323a',
  '--dt-colors-text-neutral-default-hover': '#46474f',
  '--dt-colors-text-neutral-default-active': '#5c5d66',
  '--dt-colors-text-neutral-on-accent-disabled': '#f6f6fa80',
  '--dt-colors-text-neutral-on-accent-default': '#f6f6fa',
  '--dt-colors-text-neutral-on-accent-default-hover': '#f6f6facc',
  '--dt-colors-text-neutral-on-accent-default-active': '#f6f6fa99',
  '--dt-colors-text-primary-disabled': '#5c5d6680',
  '--dt-colors-text-primary-default': '#0b56e5',
  '--dt-colors-text-primary-default-hover': '#003ac9',
  '--dt-colors-text-primary-default-active': '#0017ae',
  '--dt-colors-text-primary-on-accent-disabled': '#f7f9fc80',
  '--dt-colors-text-primary-on-accent-default': '#f7f9fc',
  '--dt-colors-text-primary-on-accent-default-hover': '#f7f9fccc',
  '--dt-colors-text-primary-on-accent-default-active': '#f7f9fc99',
  '--dt-colors-text-success-disabled': '#5c5d6680',
  '--dt-colors-text-success-default': '#007242',
  '--dt-colors-text-success-default-hover': '#005b33',
  '--dt-colors-text-success-default-active': '#004222',
  '--dt-colors-text-success-on-accent-disabled': '#080c0a80',
  '--dt-colors-text-success-on-accent-default': '#080c0a',
  '--dt-colors-text-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-text-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-text-warning-disabled': '#5c5d6680',
  '--dt-colors-text-warning-default': '#815d00',
  '--dt-colors-text-warning-default-hover': '#664800',
  '--dt-colors-text-warning-default-active': '#4c3400',
  '--dt-colors-text-warning-on-accent-disabled': '#0d0b0780',
  '--dt-colors-text-warning-on-accent-default': '#0d0b07',
  '--dt-colors-text-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-text-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-text-critical-disabled': '#5c5d6680',
  '--dt-colors-text-critical-default': '#c80026',
  '--dt-colors-text-critical-default-hover': '#a60016',
  '--dt-colors-text-critical-default-active': '#80000c',
  '--dt-colors-text-critical-on-accent-disabled': '#faf5f580',
  '--dt-colors-text-critical-on-accent-default': '#faf5f5',
  '--dt-colors-text-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-text-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-icon-neutral-disabled': '#5c5d6680',
  '--dt-colors-icon-neutral-subdued': '#5c5d66',
  '--dt-colors-icon-neutral-subdued-hover': '#46474f',
  '--dt-colors-icon-neutral-subdued-active': '#31323a',
  '--dt-colors-icon-neutral-default': '#31323a',
  '--dt-colors-icon-neutral-default-hover': '#46474f',
  '--dt-colors-icon-neutral-default-active': '#5c5d66',
  '--dt-colors-icon-neutral-on-accent-disabled': '#f6f6fa80',
  '--dt-colors-icon-neutral-on-accent-default': '#f6f6fa',
  '--dt-colors-icon-neutral-on-accent-default-hover': '#f6f6facc',
  '--dt-colors-icon-neutral-on-accent-default-active': '#f6f6fa99',
  '--dt-colors-icon-primary-disabled': '#5c5d6680',
  '--dt-colors-icon-primary-default': '#0b56e5',
  '--dt-colors-icon-primary-default-hover': '#003ac9',
  '--dt-colors-icon-primary-default-active': '#0017ae',
  '--dt-colors-icon-primary-on-accent-disabled': '#f7f9fc80',
  '--dt-colors-icon-primary-on-accent-default': '#f7f9fc',
  '--dt-colors-icon-primary-on-accent-default-hover': '#f7f9fccc',
  '--dt-colors-icon-primary-on-accent-default-active': '#f7f9fc99',
  '--dt-colors-icon-success-disabled': '#5c5d6680',
  '--dt-colors-icon-success-default': '#007242',
  '--dt-colors-icon-success-default-hover': '#005b33',
  '--dt-colors-icon-success-default-active': '#004222',
  '--dt-colors-icon-success-on-accent-disabled': '#080c0a80',
  '--dt-colors-icon-success-on-accent-default': '#080c0a',
  '--dt-colors-icon-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-icon-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-icon-warning-disabled': '#5c5d6680',
  '--dt-colors-icon-warning-default': '#815d00',
  '--dt-colors-icon-warning-default-hover': '#664800',
  '--dt-colors-icon-warning-default-active': '#4c3400',
  '--dt-colors-icon-warning-on-accent-disabled': '#0d0b0780',
  '--dt-colors-icon-warning-on-accent-default': '#0d0b07',
  '--dt-colors-icon-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-icon-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-icon-critical-disabled': '#5c5d6680',
  '--dt-colors-icon-critical-default': '#c80026',
  '--dt-colors-icon-critical-default-hover': '#a60016',
  '--dt-colors-icon-critical-default-active': '#80000c',
  '--dt-colors-icon-critical-on-accent-disabled': '#faf5f580',
  '--dt-colors-icon-critical-on-accent-default': '#faf5f5',
  '--dt-colors-icon-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-icon-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-syntax-comment': '#5e606e',
  '--dt-colors-syntax-string': '#036d66',
  '--dt-colors-syntax-variable': '#0b56e5',
  '--dt-colors-syntax-number': '#b7018c',
  '--dt-colors-syntax-punctuation': '#9215e0',
  '--dt-colors-syntax-function': '#0b56e5',
  '--dt-colors-syntax-classname': '#31323a',
  '--dt-colors-syntax-tag': '#c50222',
  '--dt-colors-syntax-operators': '#9215e0',
  '--dt-colors-syntax-boolean': '#a34400',
  '--dt-colors-charts-status-ideal-default': '#00c181',
  '--dt-colors-charts-status-good-default': '#1966ff',
  '--dt-colors-charts-status-neutral-default': '#34353d',
  '--dt-colors-charts-status-warning-default': '#fdc300',
  '--dt-colors-charts-status-critical-default': '#e01032',
};

/** Visual refresh colors — light mode. */
export const vrLightColors = {
  '--dt-colors-background-surface-backdrop':
    'color-mix(in srgb, var(--dt-colors-theme-foreground-10) 40%, transparent)',
  '--dt-colors-background-surface-backdrop-embedded':
    'color-mix(in srgb, var(--dt-colors-theme-background-10) 80%, transparent)',
  '--dt-colors-background-field-neutral-default':
    'color-mix(in srgb, var(--dt-colors-theme-neutral-20) 0%, transparent)',
  '--dt-colors-background-field-neutral-default-hover':
    'var(--dt-colors-theme-neutral-20)',
  '--dt-colors-background-field-neutral-default-active':
    'var(--dt-colors-theme-neutral-30)',
};

/** Visual refresh box shadow elements — light mode. */
export const vrLightBoxShadowElements = {
  '--_vr-shadow-0': '0 0 0 1px var(--dt-colors-border-neutral-subdued)',
  '--_vr-shadow-1':
    '0 1px 2px 0 color-mix(in srgb, var(--dt-colors-theme-foreground-10) 5%, transparent)',
  '--_vr-shadow-2-20':
    '0 4px 8px -2px color-mix(in srgb, var(--dt-colors-theme-foreground-10) 7%, transparent)',
  '--_vr-shadow-2-30':
    '0 5px 11px -2px color-mix(in srgb, var(--dt-colors-theme-foreground-10) 16%, transparent)',
  '--_vr-shadow-2-40':
    '0 6px 14px -2px color-mix(in srgb, var(--dt-colors-theme-foreground-10) 24%, transparent)',
  '--_vr-shadow-2-50':
    '0 7px 17px -2px color-mix(in srgb, var(--dt-colors-theme-foreground-10) 32%, transparent)',
};

/** Visual refresh box shadow compositions — light mode. */
export const vrLightBoxShadowCompositions = {
  '--_vr-10': 'var(--_vr-shadow-0)',
  '--_vr-20':
    'var(--_vr-shadow-1), var(--_vr-shadow-2-20), var(--_vr-shadow-0)',
  '--_vr-30':
    'var(--_vr-shadow-1), var(--_vr-shadow-2-30), var(--_vr-shadow-0)',
  '--_vr-40':
    'var(--_vr-shadow-1), var(--_vr-shadow-2-40), var(--_vr-shadow-0)',
  '--_vr-50':
    'var(--_vr-shadow-1), var(--_vr-shadow-2-50), var(--_vr-shadow-0)',
};

/** Visual refresh generated overrides — dark mode. */
export const vrDarkGeneratedOverrides = {
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 4px 8px #16161dcc',
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #f0f0f514',
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 13px 8px #16161dcc',
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 4px 8px #16161dcc',
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 7px 8px #16161dcc',
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 4px 8px #16161dcc',
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 13px 8px #16161dcc',
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 7px 8px #16161dcc',
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 10px 8px #16161dcc',
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 7px 8px #16161dcc',
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #16161d, 0px 13px 8px #16161dcc',
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #ebebee1f, inset 0px 1px 0px #ebebee14, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1b1b22',
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #ebebee1f, inset 0px 1px 0px #ebebee14, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #292931',
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #ebebee1f, inset 0px 1px 0px #ebebee14, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #34343b',
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #ffffff4d, inset 0px 1px 0px #ffffff8c, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #ebebee12, inset 0px 1px 0px #ebebee0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #dcedff0f, inset 0px 1px 0px #dcedff1a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1c2d4d',
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #dcedff0f, inset 0px 1px 0px #dcedff1a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1d315a',
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #dcedff0f, inset 0px 1px 0px #dcedff1a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1d3667',
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #dcedff26, inset 0px 1px 0px #dcedff40, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #ebebee12, inset 0px 1px 0px #ebebee0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #b7f8d60f, inset 0px 1px 0px #b7f8d61a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1e3b2d',
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #b7f8d60f, inset 0px 1px 0px #b7f8d61a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #1f4332',
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #b7f8d60f, inset 0px 1px 0px #b7f8d61a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #204c38',
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #b7f8d633, inset 0px 1px 0px #b7f8d640, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #ebebee12, inset 0px 1px 0px #ebebee0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #ffedc00f, inset 0px 1px 0px #ffedc01a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #45391d',
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #ffedc00f, inset 0px 1px 0px #ffedc01a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #52431f',
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #ffedc00f, inset 0px 1px 0px #ffedc01a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #5e4c20',
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #ffedc040, inset 0px 1px 0px #ffedc073, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #ebebee12, inset 0px 1px 0px #ebebee0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #ffe4e10f, inset 0px 1px 0px #ffe4e11a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #482220',
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #ffe4e10f, inset 0px 1px 0px #ffe4e11a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #532322',
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #ffe4e10f, inset 0px 1px 0px #ffe4e11a, 0px 1px 1px -1px #16161d80, inset 0px 0px 0px 1px #5e2423',
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #ffe4e133, inset 0px 1px 0px #ffe4e140, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #ebebee12, inset 0px 1px 0px #ebebee0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-colors-theme-foreground-10': '#f0f0f5',
  '--dt-colors-theme-foreground-20': '#16161d',
  '--dt-colors-theme-background-10': '#1b1b22',
  '--dt-colors-theme-background-20': '#16161d',
  '--dt-colors-theme-background-shell-default': '#141419',
  '--dt-colors-theme-background-base-default': '#16161d',
  '--dt-colors-theme-background-surface-backdrop': '#16161dcc',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#16161dcc',
  '--dt-colors-theme-background-surface-default': '#1b1b22',
  '--dt-colors-theme-background-container-neutral-subdued': '#16161d',
  '--dt-colors-theme-neutral-10': '#1f1f26',
  '--dt-colors-theme-neutral-20': '#292931',
  '--dt-colors-theme-neutral-30': '#34343b',
  '--dt-colors-theme-neutral-40': '#3f3f47',
  '--dt-colors-theme-neutral-50': '#4b4a52',
  '--dt-colors-theme-neutral-60': '#56565e',
  '--dt-colors-theme-neutral-70': '#dbdbe1',
  '--dt-colors-theme-neutral-80': '#ebebf2',
  '--dt-colors-theme-neutral-90': '#fcfcff',
  '--dt-colors-theme-primary-10': '#1c2434',
  '--dt-colors-theme-primary-20': '#1c2940',
  '--dt-colors-theme-primary-30': '#1c2d4d',
  '--dt-colors-theme-primary-40': '#1d315a',
  '--dt-colors-theme-primary-50': '#1d3667',
  '--dt-colors-theme-primary-60': '#1c3a75',
  '--dt-colors-theme-primary-70': '#115aed',
  '--dt-colors-theme-primary-80': '#0049db',
  '--dt-colors-theme-primary-90': '#0036ca',
  '--dt-colors-theme-success-10': '#1a2a22',
  '--dt-colors-theme-success-20': '#1c3227',
  '--dt-colors-theme-success-30': '#1e3b2d',
  '--dt-colors-theme-success-40': '#1f4332',
  '--dt-colors-theme-success-50': '#204c38',
  '--dt-colors-theme-success-60': '#21553e',
  '--dt-colors-theme-success-70': '#03a570',
  '--dt-colors-theme-success-80': '#2ab57f',
  '--dt-colors-theme-success-90': '#41c58e',
  '--dt-colors-theme-warning-10': '#2e2719',
  '--dt-colors-theme-warning-20': '#39301b',
  '--dt-colors-theme-warning-30': '#45391d',
  '--dt-colors-theme-warning-40': '#52431f',
  '--dt-colors-theme-warning-50': '#5e4c20',
  '--dt-colors-theme-warning-60': '#6b5620',
  '--dt-colors-theme-warning-70': '#dfac01',
  '--dt-colors-theme-warning-80': '#f0bc2b',
  '--dt-colors-theme-warning-90': '#ffcc43',
  '--dt-colors-theme-critical-10': '#321e1d',
  '--dt-colors-theme-critical-20': '#3d201f',
  '--dt-colors-theme-critical-30': '#482220',
  '--dt-colors-theme-critical-40': '#532322',
  '--dt-colors-theme-critical-50': '#5e2423',
  '--dt-colors-theme-critical-60': '#692425',
  '--dt-colors-theme-critical-70': '#cd0c2c',
  '--dt-colors-theme-critical-80': '#bb001c',
  '--dt-colors-theme-critical-90': '#a30014',
  '--dt-colors-background-base-default': '#16161d',
  '--dt-colors-background-surface-backdrop': '#16161dcc',
  '--dt-colors-background-surface-backdrop-embedded': '#16161dcc',
  '--dt-colors-background-surface-default': '#1b1b22',
  '--dt-colors-background-container-neutral-subdued': '#16161d',
  '--dt-colors-background-container-neutral-default': '#1f1f26',
  '--dt-colors-background-container-neutral-emphasized': '#292931',
  '--dt-colors-background-container-neutral-accent': '#dbdbe1',
  '--dt-colors-background-container-primary-default': '#1c2434',
  '--dt-colors-background-container-primary-emphasized': '#1c2940',
  '--dt-colors-background-container-primary-accent': '#115aed',
  '--dt-colors-background-container-success-default': '#1a2a22',
  '--dt-colors-background-container-success-emphasized': '#1c3227',
  '--dt-colors-background-container-success-accent': '#03a570',
  '--dt-colors-background-container-warning-default': '#2e2719',
  '--dt-colors-background-container-warning-emphasized': '#39301b',
  '--dt-colors-background-container-warning-accent': '#dfac01',
  '--dt-colors-background-container-critical-default': '#321e1d',
  '--dt-colors-background-container-critical-emphasized': '#3d201f',
  '--dt-colors-background-container-critical-accent': '#cd0c2c',
  '--dt-colors-background-field-neutral-disabled': '#34343b80',
  '--dt-colors-background-field-neutral-default': '#29293100',
  '--dt-colors-background-field-neutral-default-hover': '#292931',
  '--dt-colors-background-field-neutral-default-active': '#34343b',
  '--dt-colors-background-field-neutral-emphasized': '#34343b',
  '--dt-colors-background-field-neutral-emphasized-hover': '#3f3f47',
  '--dt-colors-background-field-neutral-emphasized-active': '#4b4a52',
  '--dt-colors-background-field-neutral-accent': '#dbdbe1',
  '--dt-colors-background-field-neutral-accent-hover': '#ebebf2',
  '--dt-colors-background-field-neutral-accent-active': '#fcfcff',
  '--dt-colors-background-field-primary-disabled': '#34343b80',
  '--dt-colors-background-field-primary-default': '#1c2d4d00',
  '--dt-colors-background-field-primary-default-hover': '#1d315a',
  '--dt-colors-background-field-primary-default-active': '#1d3667',
  '--dt-colors-background-field-primary-emphasized': '#1c2d4d',
  '--dt-colors-background-field-primary-emphasized-hover': '#1d315a',
  '--dt-colors-background-field-primary-emphasized-active': '#1d3667',
  '--dt-colors-background-field-primary-accent': '#115aed',
  '--dt-colors-background-field-primary-accent-hover': '#0049db',
  '--dt-colors-background-field-primary-accent-active': '#0036ca',
  '--dt-colors-background-field-success-disabled': '#34343b80',
  '--dt-colors-background-field-success-default': '#1e3b2d00',
  '--dt-colors-background-field-success-default-hover': '#1f4332',
  '--dt-colors-background-field-success-default-active': '#204c38',
  '--dt-colors-background-field-success-emphasized': '#1e3b2d',
  '--dt-colors-background-field-success-emphasized-hover': '#1f4332',
  '--dt-colors-background-field-success-emphasized-active': '#204c38',
  '--dt-colors-background-field-success-accent': '#03a570',
  '--dt-colors-background-field-success-accent-hover': '#2ab57f',
  '--dt-colors-background-field-success-accent-active': '#41c58e',
  '--dt-colors-background-field-warning-disabled': '#34343b80',
  '--dt-colors-background-field-warning-default': '#45391d00',
  '--dt-colors-background-field-warning-default-hover': '#52431f',
  '--dt-colors-background-field-warning-default-active': '#5e4c20',
  '--dt-colors-background-field-warning-emphasized': '#45391d',
  '--dt-colors-background-field-warning-emphasized-hover': '#52431f',
  '--dt-colors-background-field-warning-emphasized-active': '#5e4c20',
  '--dt-colors-background-field-warning-accent': '#dfac01',
  '--dt-colors-background-field-warning-accent-hover': '#f0bc2b',
  '--dt-colors-background-field-warning-accent-active': '#ffcc43',
  '--dt-colors-background-field-critical-disabled': '#34343b80',
  '--dt-colors-background-field-critical-default': '#48222000',
  '--dt-colors-background-field-critical-default-hover': '#532322',
  '--dt-colors-background-field-critical-default-active': '#5e2423',
  '--dt-colors-background-field-critical-emphasized': '#482220',
  '--dt-colors-background-field-critical-emphasized-hover': '#532322',
  '--dt-colors-background-field-critical-emphasized-active': '#5e2423',
  '--dt-colors-background-field-critical-accent': '#cd0c2c',
  '--dt-colors-background-field-critical-accent-hover': '#bb001c',
  '--dt-colors-background-field-critical-accent-active': '#a30014',
  '--dt-colors-background-shell-default': '#141419',
  '--dt-colors-border-neutral-disabled': '#3f3f4780',
  '--dt-colors-border-neutral-default': '#3f3f47',
  '--dt-colors-border-neutral-default-hover': '#4b4a52',
  '--dt-colors-border-neutral-default-active': '#56565e',
  '--dt-colors-border-neutral-accent': '#b1b1b7',
  '--dt-colors-border-neutral-accent-hover': '#ceced3',
  '--dt-colors-border-neutral-accent-active': '#ebebee',
  '--dt-colors-border-neutral-on-accent-disabled': '#0b0b0f33',
  '--dt-colors-border-neutral-on-accent-default': '#0b0b0f',
  '--dt-colors-border-neutral-on-accent-default-hover': '#0b0b0fcc',
  '--dt-colors-border-neutral-on-accent-default-active': '#0b0b0f99',
  '--dt-colors-border-neutral-subdued': '#34343b',
  '--dt-colors-border-neutral-subdued-hover': '#4b4a52',
  '--dt-colors-border-neutral-subdued-active': '#56565e',
  '--dt-colors-border-primary-disabled': '#3f3f4780',
  '--dt-colors-border-primary-default': '#1d315a',
  '--dt-colors-border-primary-default-hover': '#1d3667',
  '--dt-colors-border-primary-default-active': '#1c3a75',
  '--dt-colors-border-primary-accent': '#85b3ff',
  '--dt-colors-border-primary-accent-hover': '#aed0ff',
  '--dt-colors-border-primary-accent-active': '#dcedff',
  '--dt-colors-border-primary-on-accent-disabled': '#f5f7fa33',
  '--dt-colors-border-primary-on-accent-default': '#f5f7fa',
  '--dt-colors-border-primary-on-accent-default-hover': '#f5f7facc',
  '--dt-colors-border-primary-on-accent-default-active': '#f5f7fa99',
  '--dt-colors-border-success-disabled': '#3f3f4780',
  '--dt-colors-border-success-default': '#1f4332',
  '--dt-colors-border-success-default-hover': '#204c38',
  '--dt-colors-border-success-default-active': '#21553e',
  '--dt-colors-border-success-accent': '#4ec792',
  '--dt-colors-border-success-accent-hover': '#6ee5ae',
  '--dt-colors-border-success-accent-active': '#b7f8d6',
  '--dt-colors-border-success-on-accent-disabled': '#080c0a33',
  '--dt-colors-border-success-on-accent-default': '#080c0a',
  '--dt-colors-border-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-border-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-border-warning-disabled': '#3f3f4780',
  '--dt-colors-border-warning-default': '#52431f',
  '--dt-colors-border-warning-default-hover': '#5e4c20',
  '--dt-colors-border-warning-default-active': '#6b5620',
  '--dt-colors-border-warning-accent': '#ddad23',
  '--dt-colors-border-warning-accent-hover': '#fbca4c',
  '--dt-colors-border-warning-accent-active': '#ffedc0',
  '--dt-colors-border-warning-on-accent-disabled': '#0d0b0733',
  '--dt-colors-border-warning-on-accent-default': '#0d0b07',
  '--dt-colors-border-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-border-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-border-critical-disabled': '#3f3f4780',
  '--dt-colors-border-critical-default': '#532322',
  '--dt-colors-border-critical-default-hover': '#5e2423',
  '--dt-colors-border-critical-default-active': '#692425',
  '--dt-colors-border-critical-accent': '#ff918d',
  '--dt-colors-border-critical-accent-hover': '#ffb9b4',
  '--dt-colors-border-critical-accent-active': '#ffe4e1',
  '--dt-colors-border-critical-on-accent-disabled': '#faf5f533',
  '--dt-colors-border-critical-on-accent-default': '#faf5f5',
  '--dt-colors-border-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-border-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-text-neutral-disabled': '#b1b1b780',
  '--dt-colors-text-neutral-subdued': '#b1b1b7',
  '--dt-colors-text-neutral-subdued-hover': '#ceced3',
  '--dt-colors-text-neutral-subdued-active': '#ebebee',
  '--dt-colors-text-neutral-default': '#ebebee',
  '--dt-colors-text-neutral-default-hover': '#ceced3',
  '--dt-colors-text-neutral-default-active': '#b1b1b7',
  '--dt-colors-text-neutral-on-accent-disabled': '#0b0b0f80',
  '--dt-colors-text-neutral-on-accent-default': '#0b0b0f',
  '--dt-colors-text-neutral-on-accent-default-hover': '#0b0b0fcc',
  '--dt-colors-text-neutral-on-accent-default-active': '#0b0b0f99',
  '--dt-colors-text-primary-disabled': '#b1b1b780',
  '--dt-colors-text-primary-default': '#85b3ff',
  '--dt-colors-text-primary-default-hover': '#aed0ff',
  '--dt-colors-text-primary-default-active': '#dcedff',
  '--dt-colors-text-primary-on-accent-disabled': '#f5f7fa80',
  '--dt-colors-text-primary-on-accent-default': '#f5f7fa',
  '--dt-colors-text-primary-on-accent-default-hover': '#f5f7facc',
  '--dt-colors-text-primary-on-accent-default-active': '#f5f7fa99',
  '--dt-colors-text-success-disabled': '#b1b1b780',
  '--dt-colors-text-success-default': '#4ec792',
  '--dt-colors-text-success-default-hover': '#6ee5ae',
  '--dt-colors-text-success-default-active': '#b7f8d6',
  '--dt-colors-text-success-on-accent-disabled': '#080c0a80',
  '--dt-colors-text-success-on-accent-default': '#080c0a',
  '--dt-colors-text-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-text-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-text-warning-disabled': '#b1b1b780',
  '--dt-colors-text-warning-default': '#ddad23',
  '--dt-colors-text-warning-default-hover': '#fbca4c',
  '--dt-colors-text-warning-default-active': '#ffedc0',
  '--dt-colors-text-warning-on-accent-disabled': '#0d0b0780',
  '--dt-colors-text-warning-on-accent-default': '#0d0b07',
  '--dt-colors-text-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-text-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-text-critical-disabled': '#b1b1b780',
  '--dt-colors-text-critical-default': '#ff918d',
  '--dt-colors-text-critical-default-hover': '#ffb9b4',
  '--dt-colors-text-critical-default-active': '#ffe4e1',
  '--dt-colors-text-critical-on-accent-disabled': '#faf5f580',
  '--dt-colors-text-critical-on-accent-default': '#faf5f5',
  '--dt-colors-text-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-text-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-icon-neutral-disabled': '#b1b1b780',
  '--dt-colors-icon-neutral-subdued': '#b1b1b7',
  '--dt-colors-icon-neutral-subdued-hover': '#ceced3',
  '--dt-colors-icon-neutral-subdued-active': '#ebebee',
  '--dt-colors-icon-neutral-default': '#ebebee',
  '--dt-colors-icon-neutral-default-hover': '#ceced3',
  '--dt-colors-icon-neutral-default-active': '#b1b1b7',
  '--dt-colors-icon-neutral-on-accent-disabled': '#0b0b0f80',
  '--dt-colors-icon-neutral-on-accent-default': '#0b0b0f',
  '--dt-colors-icon-neutral-on-accent-default-hover': '#0b0b0fcc',
  '--dt-colors-icon-neutral-on-accent-default-active': '#0b0b0f99',
  '--dt-colors-icon-primary-disabled': '#b1b1b780',
  '--dt-colors-icon-primary-default': '#85b3ff',
  '--dt-colors-icon-primary-default-hover': '#aed0ff',
  '--dt-colors-icon-primary-default-active': '#dcedff',
  '--dt-colors-icon-primary-on-accent-disabled': '#f5f7fa80',
  '--dt-colors-icon-primary-on-accent-default': '#f5f7fa',
  '--dt-colors-icon-primary-on-accent-default-hover': '#f5f7facc',
  '--dt-colors-icon-primary-on-accent-default-active': '#f5f7fa99',
  '--dt-colors-icon-success-disabled': '#b1b1b780',
  '--dt-colors-icon-success-default': '#4ec792',
  '--dt-colors-icon-success-default-hover': '#6ee5ae',
  '--dt-colors-icon-success-default-active': '#b7f8d6',
  '--dt-colors-icon-success-on-accent-disabled': '#080c0a80',
  '--dt-colors-icon-success-on-accent-default': '#080c0a',
  '--dt-colors-icon-success-on-accent-default-hover': '#080c0acc',
  '--dt-colors-icon-success-on-accent-default-active': '#080c0a99',
  '--dt-colors-icon-warning-disabled': '#b1b1b780',
  '--dt-colors-icon-warning-default': '#ddad23',
  '--dt-colors-icon-warning-default-hover': '#fbca4c',
  '--dt-colors-icon-warning-default-active': '#ffedc0',
  '--dt-colors-icon-warning-on-accent-disabled': '#0d0b0780',
  '--dt-colors-icon-warning-on-accent-default': '#0d0b07',
  '--dt-colors-icon-warning-on-accent-default-hover': '#0d0b07cc',
  '--dt-colors-icon-warning-on-accent-default-active': '#0d0b0799',
  '--dt-colors-icon-critical-disabled': '#b1b1b780',
  '--dt-colors-icon-critical-default': '#ff918d',
  '--dt-colors-icon-critical-default-hover': '#ffb9b4',
  '--dt-colors-icon-critical-default-active': '#ffe4e1',
  '--dt-colors-icon-critical-on-accent-disabled': '#faf5f580',
  '--dt-colors-icon-critical-on-accent-default': '#faf5f5',
  '--dt-colors-icon-critical-on-accent-default-hover': '#faf5f5cc',
  '--dt-colors-icon-critical-on-accent-default-active': '#faf5f599',
  '--dt-colors-syntax-comment': '#b2b3cd',
  '--dt-colors-syntax-string': '#39d0b5',
  '--dt-colors-syntax-variable': '#82b3ff',
  '--dt-colors-syntax-number': '#ff94eb',
  '--dt-colors-syntax-punctuation': '#d6a5fd',
  '--dt-colors-syntax-function': '#82b3ff',
  '--dt-colors-syntax-classname': '#eaeaf0',
  '--dt-colors-syntax-tag': '#ff9eae',
  '--dt-colors-syntax-operators': '#d6a5fd',
  '--dt-colors-syntax-boolean': '#ffa27a',
  '--dt-colors-charts-status-ideal-default': '#03a570',
  '--dt-colors-charts-status-good-default': '#115aed',
  '--dt-colors-charts-status-neutral-default': '#dbdbe1',
  '--dt-colors-charts-status-warning-default': '#dfac01',
  '--dt-colors-charts-status-critical-default': '#cd0c2c',
};

/** Visual refresh colors — dark mode. */
export const vrDarkColors = {
  '--dt-colors-background-surface-backdrop':
    'color-mix(in srgb, var(--dt-colors-theme-foreground-20) 80%, transparent)',
  '--dt-colors-background-surface-backdrop-embedded':
    'color-mix(in srgb, var(--dt-colors-theme-background-20) 80%, transparent)',
  '--dt-colors-background-surface-default':
    'var(--dt-colors-theme-background-10)',
  '--dt-colors-background-base-default': 'var(--dt-colors-theme-background-20)',
  '--dt-colors-background-container-neutral-subdued':
    'var(--dt-colors-theme-background-20)',
};

/** Visual refresh box shadow elements — dark mode. */
export const vrDarkBoxShadowElements = {
  '--_vr-shadow-0': '0 0 0 1px var(--dt-colors-border-neutral-subdued)',
  '--_vr-shadow-1': '0 1px 2px 0 var(--dt-colors-theme-foreground-20)',
  '--_vr-shadow-2-20':
    '0 4px 8px color-mix(in srgb, var(--dt-colors-theme-foreground-20) 80%, transparent)',
  '--_vr-shadow-2-30':
    '0 7px 8px color-mix(in srgb, var(--dt-colors-theme-foreground-20) 80%, transparent)',
  '--_vr-shadow-2-40':
    '0 10px 8px color-mix(in srgb, var(--dt-colors-theme-foreground-20) 80%, transparent)',
  '--_vr-shadow-2-50':
    '0 13px 8px color-mix(in srgb, var(--dt-colors-theme-foreground-20) 80%, transparent)',
};

/** Visual refresh box shadow compositions — dark mode. */
export const vrDarkBoxShadowCompositions = {
  '--_vr-10': 'var(--_vr-shadow-0)',
  '--_vr-20':
    'var(--_vr-shadow-0), var(--_vr-shadow-1), var(--_vr-shadow-2-20)',
  '--_vr-30':
    'var(--_vr-shadow-0), var(--_vr-shadow-1), var(--_vr-shadow-2-30)',
  '--_vr-40':
    'var(--_vr-shadow-0), var(--_vr-shadow-1), var(--_vr-shadow-2-40)',
  '--_vr-50':
    'var(--_vr-shadow-0), var(--_vr-shadow-1), var(--_vr-shadow-2-50)',
};
